import { render, staticRenderFns } from "./LoginOpt.vue?vue&type=template&id=2fa52c9c&scoped=true&"
import script from "./LoginOpt.vue?vue&type=script&lang=js&"
export * from "./LoginOpt.vue?vue&type=script&lang=js&"
import style0 from "./LoginOpt.vue?vue&type=style&index=0&id=2fa52c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa52c9c",
  null
  
)

export default component.exports